import React from 'react';
import { useTranslation } from 'react-i18next';

interface FeedbackOverlayProps {
  isCorrect: boolean;
  feedback: string;
  onContinue: () => void;
  isLast?: boolean;
}

const FeedbackOverlay: React.FC<FeedbackOverlayProps> = ({
  isCorrect,
  feedback,
  onContinue,
  isLast = false,
}) => {
  const { t } = useTranslation('trivia');

  return (
    <div className="fixed inset-0 z-50 flex items-end">
      <div className="absolute inset-0 bg-black/60" />
      <div className="relative w-full animate-slide-up">
        <div
          className={`m-4 rounded-3xl p-6 border ${
            isCorrect
              ? 'bg-green-900/90 border-green-500/50'
              : 'bg-red-900/90 border-red-500/50'
          } backdrop-blur-sm`}
        >
          <div className="flex items-center gap-3 mb-3">
            <span className="text-4xl">{isCorrect ? '\u2705' : '\u274C'}</span>
            <span
              className={`text-xl font-bold ${
                isCorrect ? 'text-green-300' : 'text-red-300'
              }`}
            >
              {isCorrect ? t('feedback.correct') : t('feedback.incorrect')}
            </span>
          </div>
          <p className="text-white/90 text-base leading-relaxed mb-5">{feedback}</p>
          <button
            onClick={onContinue}
            className="w-full py-4 rounded-2xl bg-white text-navy font-bold text-base min-h-[56px] hover:bg-gray-100 active:scale-[0.98] transition-all"
          >
            {isLast ? t('feedback.viewResult') : t('feedback.next')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackOverlay;
